<template>
  <div class="column q-col-gutter-y-xs">
    <!-- <div class="row q-col-gutter-x-xs items-center">
      <q-badge style="background-color: #f44336; width: 20px"></q-badge>
      <div>总制动力</div>
    </div> -->
    <div class="row q-col-gutter-x-xs items-center">
      <q-badge style="background-color: #2196f3; width: 20px"></q-badge>
      <div>摩擦制动力</div>
    </div>
    <div class="row q-col-gutter-x-xs items-center">
      <q-badge style="background-color: #f44336; width: 20px"></q-badge>
      <div>电制动力</div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
<style scoped></style>
